<form [formGroup]="form1" (ngSubmit)="create()" *ngIf="storesId else notStore">
    <div class="card">
      <div class="card-header text-center" style="text-transform: uppercase">
        AGREGAR VEHÍCULO
      </div>
      <div class="card-body">
        <div class="row gx-3 mb-3">
          <!-- Tipo de Vehículo -->
          <div class="col-md-6 col-sm-12">


            <label class="small mb-1" for="cars_type">Tipo</label>
            
            <app-suggestion-input 
            [fontawesomeLabelIcon]="'fa-solid fa-car'" 
            [showButton]="false"  [items]="types"
            (onSelected)="form1.get('types_id')?.setValue($event?.id)"
            [initValueId]="134"
            [control]="form1.controls['type']" />
            
          </div>
  
          <!-- Placa Patente -->
          <div class="col-md-6 col-sm-12">
            <label class="small mb-1" for="ppu">Placa Patente</label>
            <div class="input-group">
              <input type="text" class="form-control text-uppercase" uppercase formControlName="ppu" />
            </div>
          </div>
  
          <!-- Marca del Vehículo -->
          <div class="col-md-6 col-sm-12">
            <label class="small mb-1" for="brand">Marca</label>
            <app-suggestion-input 
            [fontawesomeLabelIcon]="'fa-solid fa-hashtag'" 
            [showButton]="false"  [items]="brands"
            (onSelected)="form1.get('brands_id')?.setValue($event?.id)"
            [control]="form1.controls['brand']" />
          </div>
  
          <!-- Modelo del Vehículo -->
          <div class="col-md-6 col-sm-12">
            <label class="small mb-1" for="model">Modelo</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="model" />
            </div>
          </div>
  
          <div class="col-md-6 col-sm-12">
            <label class="small mb-1" for="parking">Estacionamiento</label>
            <div class="input-group">
              <input type="text" class="form-control text-uppercase" formControlName="parking" />
            </div>
          </div>

          <div class="col-md-6 col-sm-12">
            <label class="small mb-1" for="parking">Estado</label>
            <div class="input-group">
              <select type="text" class="form-control text-uppercase" formControlName="state_id" >
                <option value="1">AUTORIZADO</option>
                <option value="2">NO AUTORIZADO</option>
              </select>
            </div>
          </div>
          
          <div class="col-md-12 col-sm-12">
            <label class="small mb-1" for="obs">Observación</label>
            <div class="input-group">
              <textarea type="text" class="form-control" formControlName="obs"></textarea>
            </div>
          </div>
        </div>
  
        <!-- Botón de Crear -->
        <button class="btn btn-primary w-100"  type="submit">REGISTRAR</button>
      </div>
    </div>
  </form>
  
  <!-- Plantilla Alternativa Si No Existe storesId -->
  <ng-template #notStore>
    <h2>No se recibió el identificador de la dependencia, que se debe asociar</h2>
  </ng-template>
  